<template>
  <div>
    <BaseModal v-model="showNewModal">
      <div class="w-full p-12" v-if="newProduct">
        <h3 class="mb-4">New Marketplace Item</h3>
        <form class="grid grid-cols-1 gap-4" @submit.prevent="createProduct()">
          <div>
            <label for="skuAlias">Alias (SKU on marketplace)</label>
            <input
              name="skuAlias"
              class="regular bordered full"
              type="text"
              required
              v-model="newProduct.skuAlias"
            />
          </div>
          <div>
            <label for="marketplace">Marketplace</label>
            <select
              class="regular bordered full"
              name="marketplace"
              id="marketplace"
              required
              v-model="newProduct.marketplaceName"
            >
              <option value="">Select</option>
              <option value="amazon">Amazon</option>
              <option value="ebay">eBay</option>
            </select>
          </div>
          <div>
            <label for="item-id">Marketplace Item Id</label>
            <input
              class="regular bordered full"
              type="text"
              name="item-id"
              id="item-id"
              required
              v-model="newProduct.marketplaceItemId"
            />
          </div>
          <div>
            <!-- <label for="item-id">Marketplace shipping weight</label>
            <input
              class="regular bordered full"
              type="number"
              step="0.01"
              name="marketplace-shipping-weight"
              id="marketplace-shipping-weight"
              required
              v-model="newProduct.marketplaceShippingWeight"
            /> -->
            <template v-if="newProduct.marketplaceName == 'amazon'">
              (${{ priceAdjustmentShipment }} shipment)
            </template>
          </div>
          <div>
            <label for="ad-percentage">Price adjustment percentage</label>
            <input
              name="ad-percentage"
              id="ad-percentage"
              class="regular bordered full"
              type="number"
              step="0.01"
              required
              v-model="newProduct.priceAdjustmentPercentage"
            />
          </div>
          <div>
            <label for="ad-fixed">Price adjustment fixed</label>
            <input
              name="ad-fixed"
              id="ad-fixed"
              class="regular bordered full"
              type="number"
              step="0.01"
              required
              v-model="newProduct.priceAdjustmentFixed"
            />
          </div>
          <div>
            <label for="export-enabled">Export enabled</label>
            <select
              required
              class="regular bordered full"
              name="export-enabled"
              id="export-enabled"
              v-model="newProduct.enabledForExports"
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div>
            <label for="fba">Product is FBA</label>
            <select
              required
              name="fba"
              id="fba"
              class="regular bordered full"
              v-model="newProduct.fba"
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div class="flex flex-row justify-center">
            <button
              type="submit"
              class="text-white h-10 mx-2 border rounded-full p-2 bg-green-500"
            >
              Create product
            </button>
            <button
              type="button"
              class="text-white h-10 mx-2 border rounded-full p-2 bg-red-500 flex justify-center items-center"
              @click="showNewModal = false"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div
        class="ml-4 mb-4"
        v-if="newProduct && newProduct.marketplaceName === 'amazon'"
      >
        <b class="font-bold">
          Marketplace Shipping Weight
        </b>
        will affect "Adjustment Fixed" for Amazon using the formula
        <span class="text-red-500">
          7 + (MarketplaceShippingWeight X 2) = adjustmentFixed
        </span>
      </div>
    </BaseModal>
    <button class="btn-dark-button my-2 ml-2" @click="initItemCreation">
      New
    </button>
  </div>
</template>
<script>
import { createMarketplaceItem } from "@/api/store/MarketplacesItemsService.js";

export default {
  name: "ProductMarketplacesNew",
  data() {
    return {
      newProduct: null,
      showNewModal: false
    };
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  computed: {
    priceAdjustmentShipment() {
      let base = 10;
      if (this.newProduct.marketplaceShippingWeight >= 1) {
        base = 7;
      }
      return base + this.newProduct.marketplaceShippingWeight * 2;
    }
  },
  methods: {
    initItemCreation() {
      this.newProduct = {
        enabledForExports: "1",
        fba: "0",
        id: null,
        marketplaceItemId: "",
        marketplaceName: "",
        marketplaceShippingWeight: "0",
        nkrCode: this.code,
        priceAdjustmentFixed: 0,
        priceAdjustmentPercentage: "0",
        skuAlias: this.code
      };
      this.showNewModal = true;
    },
    createProduct() {
      createMarketplaceItem(this.newProduct)
        .then(res => {
          this.newProduct.id = res.id;
          this.$emit("created", this.newProduct);
          this.$toast.open({
            message: `Product created`,
            type: "success",
            position: "top-right"
          });
          this.showNewModal = false;
        })
        .catch(error => {
          this.$toast.open({
            message: error.response.data,
            type: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>
